export const logger = {
  enabled: false,

  enable() {
    this.enabled = true;
  },

  log(...args) {
    if (this.enabled) {
      // eslint-disable-next-line no-console
      console.log('BM log: ', ...args);
    }
  },

  logCond(condition, ...args) {
    if (this.enabled && condition && args.length > 1) {
      this.log(...args);
    }
  }

};